import React, { Fragment } from "react";
import { Field, FormSpy } from "react-final-form";

class TempoFieldAdapter extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.meta.active && this.props.onChange) {
      this.props.onChange(this.props.name, this.props.input.value, prevProps.input.value);
    }
  }

  render() {
    return this.props.children;
  }
}

// Wrap the ExternalModificationDetector in a Field
export default ({ name, onChange, ...rest }) => (
  <Field
    name={name}
    subscription={{ value: true, active: true }}
    render={props => (
      <TempoFieldAdapter {...props} name={name} onChange={onChange}>
        <Field name={name} {...rest} />
      </TempoFieldAdapter>
    )}
  />
);
